module.exports = __webpack_public_path__ + "static/img/dqqh.f71502e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dqqh.png
// module id = MVlL
// module chunks = 1